module.exports = __webpack_public_path__ + "img/link_yuu_id_tc.afd1aba.png";